import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {AuthTokenService} from '../services/auth-token.service';

@Directive({
  selector: '[appHasAnyAuthority]'
})
export class HasAnyAuthorityDirective {
  private authorities: string[];

  constructor(
    private authTokenService: AuthTokenService,
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef
  ) {
  }

  @Input()
  set appHasAnyAuthority(value: string | string[]) {
    this.authorities = typeof value === 'string' ? [value] : value;
    this.updateView();
    this.authTokenService.getAuthenticationState().subscribe(_ => this.updateView());
  }

  private updateView(): void {
    const hasAnyAuthority = this.authTokenService.hasAnyAuthority(this.authorities);
    this.viewContainerRef.clear();
    if (hasAnyAuthority) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/has-any-authority.directive.ts